import { Box, Count, FlexBox, Typography } from '@vp/swan'
import { useTranslation } from 'react-i18next'
import { useAppData } from '@app/providers/app-data-context'
import { parseSchedule } from '@shared/channels'
import type { ContactChannel } from '../page'

interface PageSidebarProps {
  channel: ContactChannel
}

export const PageSidebar = ({ channel }: PageSidebarProps) => {
  const { t } = useTranslation()
  const { phoneShortSchedule } = useAppData()

  const schedule = parseSchedule(phoneShortSchedule)

  const helpActionStep =
    channel === 'callback' ? t('contact_us.page.sidebar.help_steps.help_action_phone') : t('contact_us.page.sidebar.help_steps.help_action_email')

  return (
    <Box>
      <Typography display={{ xs: 'none', sm: 'block' }} fontWeight="bold" fontSize="large" mb={5}>
        {t('contact_us.page.sidebar.title')}
      </Typography>

      <FlexBox flexDirection="column" gap={4} mb={{ xs: channel === 'callback' ? 9 : 0, sm: 9 }}>
        <FlexBox alignItems="baseline" gap={3}>
          <Count mt="2">{1}</Count>
          <Typography fontSkin="body-standard-bold">{t('contact_us.page.sidebar.help_steps.issue_selection')}</Typography>
        </FlexBox>
        <FlexBox alignItems="baseline" gap={3}>
          <Count mt="2">{2}</Count>
          <Typography fontSkin="body-standard-bold">{t('contact_us.page.sidebar.help_steps.issue_description')}</Typography>
        </FlexBox>
        <FlexBox alignItems="baseline" gap={3}>
          <Count mt="2">{3}</Count>
          <Typography fontSkin="body-standard-bold">{helpActionStep}</Typography>
        </FlexBox>
      </FlexBox>

      {channel === 'callback' && (
        <Box>
          <Typography fontWeight="bold" fontSize="large" mb={4}>
            {t('contact_us.page.sidebar.working_hours')}
          </Typography>

          <FlexBox flexDirection="column" gap={2}>
            {schedule.map((entry) => (
              <FlexBox key={entry.days} justifyContent="space-between" flexWrap="wrap" gap={4}>
                <Typography color="subtle">{entry.days}</Typography>
                <Typography color="subtle">{entry.time}</Typography>
              </FlexBox>
            ))}
          </FlexBox>
        </Box>
      )}
    </Box>
  )
}
